import { login, logout, getInfo, fromOldFramework, permissions } from '@/api/Login/login';
import Cookies from 'js-cookie';

const user = {
    state: {
        user: '',
        status: '',
        email: '',
        code: '',
        uid: undefined,
        auth_type: '',
        token: Cookies.get('Admin-Token'),
        name: '',
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        },
        userInfo: {},
        schoolInfo: {},
        permissions: [],
        permissionNameMapping: {},
        departs: []
    },

    mutations: {
        SET_AUTH_TYPE: (state, type) => {
            state.auth_type = type;
        },
        SET_CODE: (state, code) => {
            state.code = code;
        },
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_UID: (state, uid) => {
            state.uid = uid;
        },
        SET_EMAIL: (state, email) => {
            state.email = email;
        },
        SET_INTRODUCTION: (state, introduction) => {
            state.introduction = introduction;
        },
        SET_SETTING: (state, setting) => {
            state.setting = setting;
        },
        SET_STATUS: (state, status) => {
            state.status = status;
        },
        SET_NAME: (state, name) => {
            state.name = name;
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar;
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles;
        },
        SET_USERINFO: (state, userInfo) => {
            state.userInfo = userInfo;
        },
        SET_SCHOOLINFO: (state, schoolInfo) => {
            state.schoolInfo = schoolInfo;
        },
        SET_PERMISSIONS: (state, permissionList) => {
            const permissions = [], permissionNameMapping = {};
            permissionList.forEach(item => {
                permissions.push(item.url.trim());
                permissionNameMapping[item.url.trim()] = item.name.trim();
            });
            state.permissions = permissions;
            state.permissionNameMapping = permissionNameMapping;
        },
        SET_DEPARTS: (state, departs) => {
            state.departs = departs;
        },
        LOGIN_SUCCESS: () => {},
        LOGOUT_USER: state => {
            state.user = '';
        }

    },

    actions: {
        // 登录
        Login({ commit, dispatch }, userInfo) {
            const account = userInfo.account.trim();
            return new Promise((resolve, reject) => {
                login(account, userInfo.password).then(response => {
                    const data = response.data.data;
                    Cookies.set('Admin-Token', data.token);
                    commit('SET_TOKEN', data.token);
                    commit('SET_USERINFO', data.userPageModel);
                    commit('SET_SCHOOLINFO', data.schoolPageModel);
                    commit('SET_ROLES', data.roleList);
                    commit('SET_DEPARTS', data.departList);
                    dispatch('GetPermission')
                        .then(() => {
                            resolve(response);
                        });
                }).catch(error => {
                    reject(error);
                });
            });
        },
        SetLoginInfo({ commit, dispatch }, userInfo){//设置登录信息，由于当前的登录逻辑中存在多学校和首次登录的验证，登录会被连续调用，故此放在用于完全验证通过后，调用，而store中login，在此不适用
            return new Promise(resolve => {
                console.log('userInfo', userInfo);
                const data = userInfo;
                Cookies.set('Admin-Token', data.token);
                commit('SET_TOKEN', data.token);
                commit('SET_USERINFO', data.userPageModel);
                commit('SET_SCHOOLINFO', data.schoolPageModel);
                commit('SET_ROLES', data.roleList);
                commit('SET_DEPARTS', data.departList);
                dispatch('GetPermission')
                    .then(() => {
                        resolve();
                    });
            });
        },
        // 获取用户信息
        GetInfo({ commit, state, dispatch }) {
            return new Promise((resolve, reject) => {
                getInfo(Cookies.get('Admin-Token')).then(response => {
                    const data = response.data.data;
                    commit('SET_TOKEN', Cookies.get('Admin-Token'));
                    commit('SET_USERINFO', data.userPageModel);
                    commit('SET_SCHOOLINFO', data.schoolPageModel);
                    commit('SET_ROLES', data.roleList);
                    commit('SET_DEPARTS', data.departList);
                    dispatch('GetPermission')
                        .then(() => {
                            resolve();
                        });
                }).catch(error => {
                    reject(error);
                });
            });
        },

        // 第三方验证登录
        LoginByThirdparty({ commit, state }, code) {
            return new Promise((resolve, reject) => {
                commit('SET_CODE', code);
                loginByThirdparty(state.status, state.email, state.code, state.auth_type).then(response => {
                    commit('SET_TOKEN', response.data.token);
                    Cookies.set('Admin-Token', response.data.token);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },


        // 登出
        LogOut({ commit, state, }) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '');
                    commit('SET_ROLES', []);
                    commit('SET_PERMISSIONS', []);
                    Cookies.remove('Admin-Token');
                    resolve();
                }).catch(error => {
                    reject(error);
                });
            });
        },

        // 前端 登出
        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '');
                Cookies.remove('Admin-Token');
                resolve();
            });
        },
        ResetPermissions({ commit }, newPermissins) { //重构Permissions,用于增加二级以后的菜单（含二级）
            return new Promise(resolve => {
                commit('SET_PERMISSIONS', newPermissins);
                resolve();
            });
        },
        FromOldFramework({ commit, state, dispatch }, userToken) {
            return new Promise((resolve, reject) => {
                fromOldFramework(userToken).then(response => {
                    const data = response.data.data;
                    Cookies.set('Admin-Token', data.token);
                    dispatch('SetInfo', data);
                    dispatch('GetPermission')
                        .then(() => {
                            resolve(response);
                        });
                }).catch(error => {
                    reject(error);
                });
            });
        },
        GetPermission({ commit, state, dispatch }) {
            return new Promise((resolve, reject) => {
                permissions().then(response => response.data)
                    .then(data => {
                        commit('SET_PERMISSIONS', data.data);
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        SetInfo({commit, state}, data) {
            commit('SET_TOKEN', Cookies.get('Admin-Token'));
            commit('SET_USERINFO', data.userPageModel);
            commit('SET_SCHOOLINFO', data.schoolPageModel);
            commit('SET_ROLES', data.roleList);
            commit('SET_DEPARTS', data.departList);
        },
    }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js